import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { Container, Button, Row, Form, Col} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { addUser } from '../../actions/usersActions'
import Swal from 'sweetalert2'
import { Link, useNavigate } from 'react-router-dom'

export default function RegisterClient() {     
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {user, resultuser, useractivate} = useSelector(state=>state.users)

    const [formState, setFormState] = useState({})

    const [islogging, setIslogging] = useState(false)
    const [isCorrect, setIsCorrect] = useState(false)
    //eslint-disable-next-line
    const [passwordverify, setPasswordverify] = useState("")
    
    const [showPasswordOne, setShowPasswordOne] = useState(false)
    const [showPasswordTwo, setShowPasswordTwo] = useState(false)

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handlePasswordVisibilityOne = () => {
        setShowPasswordOne(!showPasswordOne);
    }

    const handlePasswordVisibilityTwo = () => {
        setShowPasswordTwo(!showPasswordTwo);
    }

    const checkValidation = (isPassVer, e) => {
        const confirmPass = e.target.value;

        if(isPassVer){
            setPasswordverify(confirmPass)
        }else{
            setFormState({
                ...formState,
                'password': confirmPass
            })
        }

        if (formState.password !== confirmPass) {
            setIsCorrect(false);
        }else {
            setIsCorrect(true);
        }
    }

    const handleAdd = async(e) => {
        e.preventDefault()
        setIslogging(true)
        if(isCorrect){
            if(formState.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,15}$/g)){
                dispatch(addUser(formState))
            }else{
                Swal.fire({
                    showConfirmButton: true,
                    icon: 'warning',
                    text: t('users.passwordsnotvalid')
                })
            }
        }else{
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('users.passwordsnotmatch')
            })
        }
        setIslogging(false)
    }
    useEffect(() => {
        setFormState({
            firstname: '',
            phone: '',
            birthdate: '',
            email: '',
            password: '',
        })
    }, [user, dispatch])

    useEffect(() => {
        if(resultuser){
            switch (resultuser) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('users.gotoverify'),
                        icon: 'success',
                        text: t('users.useradd')
                    }).then((resultuser) => {
                        if (resultuser.isConfirmed) {
                            navigate('/activation/'+useractivate)
                        }
                    })
                    break;
                case 'email':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('users.emailduplicate')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultuser])

    return (
        <Container>
            <Row className="my-3 d-flex align-content-center">
                <Col className='p-0 d-flex align-content-center'>
                    <Link className="btn my-3 px-5" to="/login">
                        <img src="../images/arrow-back.svg" alt="eyes" width={25}></img>
                    </Link>
                </Col>
                <Col className='text-center'>
                    <h1 className='m-3'>{t('users.registration')}</h1>
                </Col>
                <Col></Col>
            </Row>
            <Row className="my-3 p-4">
                <Col className="justify-content-center">
                    <Form className="px-4 formulario" onSubmit={handleAdd}>
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start">{t('users.firstname')}</h2>
                            <Form.Control
                                className="sd-input"
                                type='text'
                                name='firstname' 
                                value={formState.firstname ||  ''}
                                placeholder={t('users.setfirstname')}
                                onChange={handleInputChange}
                                required
                            />
                        </Row>
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start">{t('users.phone')}</h2>
                            <Form.Control
                                className="sd-input"
                                type='text'
                                name='phone' 
                                value={formState.phone ||  ''}
                                placeholder={t('users.setphone')}
                                onChange={handleInputChange}
                                required
                            />
                        </Row>
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start">{t('users.birthdate')}</h2>
                            <Form.Control
                                className="sd-input"
                                type='date'
                                name='birthdate' 
                                value={formState.birthdate ||  ''}
                                placeholder={t('users.birthdate')}
                                onChange={handleInputChange}
                                required
                            />
                        </Row>
                        <Row className="text-center my-3">
                            <h2 className="sd-label text-start">{t('users.email')}</h2>
                            <Form.Control
                                className="sd-input"
                                type='email'
                                name='email' 
                                value={formState.email || ''}
                                placeholder={t('users.setemail')}
                                onChange={handleInputChange}
                                required
                            />
                        </Row>
                        <Row className="text-center mt-3">
                            <h2 className="sd-label text-start">{t('users.password')}</h2>
                        </Row>
                        <Row className="text-center mb-3 row-eye">
                            <Form.Control
                                className="sd-input"
                                type={showPasswordOne ? 'text' : 'password'}
                                name='password' 
                                value={formState.password ||  ''}
                                placeholder={t('users.setpassword')}
                                onChange={(e) => checkValidation(false, e)}
                                required
                            />
                            <img className="sd-imageneye" src={showPasswordOne ? "../images/eyeclose.svg" : "../images/eyeopen.svg"} alt="eyes" width={15} onClick={handlePasswordVisibilityOne}></img>
                        </Row>
                        <Row className="my-3">
                            <p>
                                <span className='fs-12 fw-400 ps-1'>{t('users.passwordneed1')}</span><br/>
                                <span className='password-list'>
                                    <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed2')}</span>
                                    <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed3')}</span>
                                    <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed4')}</span>
                                </span>
                            </p>
                        </Row>
                        <Row className="text-center mt-3">
                            <h2 className="sd-label text-start">{t('users.passwordconfirm')}</h2>
                        </Row>
                        <Row className="text-center mb-3 row-eye">
                            <Form.Control
                                className="sd-input"
                                type={showPasswordTwo ? 'text' : 'password'}
                                name='passwordcheck'
                                placeholder={t('users.setpasswordconfirm')}
                                onChange={(e) => checkValidation(true, e)}
                                required
                            />
                            <img className="sd-imageneye" src={showPasswordTwo ? "../images/eyeclose.svg" : "../images/eyeopen.svg"} alt="eyes" width={15} onClick={handlePasswordVisibilityTwo}></img>
                        </Row>
                        <Row className="text-center my-3">
                            <Col>
                                <Button variant='primary' type="submit" className="btn-primary w-100 my-2">
                                {islogging
                                    ?
                                        <>
                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </>
                                    :
                                        <>{t('users.register')}</>
                                }
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}
